export default {
  slate: {
    50: '#ebf1fd',
    100: '#cfd6e5',
    200: '#b1bbce',
    300: '#92a0b9',
    400: '#7485a5',
    500: '#5a6c8b',
    600: '#46546d',
    700: '#313c4e',
    800: '#1b2431',
    900: '#060c17',
  },
  subtle: '#52555A',
};
